import { render, staticRenderFns } from "./Form15StyleOfProceeding.vue?vue&type=template&id=2719bdaa&scoped=true"
import script from "./Form15StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form15StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form15StyleOfProceeding.vue?vue&type=style&index=0&id=2719bdaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719bdaa",
  null
  
)

export default component.exports